/**
 * 塾ページのルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import Login from '../views/academy/Login.vue'
import QrLogin from '../views/academy/QrLogin.vue'
import StudyManagement from '../views/academy/StudyManagement.vue'
import StudyManagementCandidate from '../views/academy/StudyManagementCandidate.vue'
import TeacherManagement from '../views/academy/TeacherManagement.vue'
import StudentManagement from '../views/academy/StudentManagement.vue'
import StudyResultManagement from '../views/academy/history/StudyResultManagement.vue'

/**
 * 塾側ページ群
 *   nameに接頭辞'Academy'を付ける
 */
const academyRoutes: Array<RouteConfig> = [
  {
    path: '/academy/login',
    name: 'AcademyLogin',
    component: Login,
  },
  {
    path: '/academy/qr-login',
    name: 'AcademyQrLogin',
    component: QrLogin,
  },
  {
    path: '/academy/study-management',
    name: 'AcademyStudyManagement',
    component: StudyManagement,
  },
  {
    path: '/academy/study-management-candidate/:studyId',
    name: 'AcademyStudyManagementCandidate',
    component: StudyManagementCandidate,
  },
  {
    path: '/academy/teacher-management',
    name: 'AcademyTeacherManagement',
    component: TeacherManagement,
  },
  {
    path: '/academy/student-management',
    name: 'AcademyStudentManagement',
    component: StudentManagement,
  },
  {
    path: '/academy/history/study-result-management',
    name: 'AcademyHistoryStudyResultManagement',
    component: StudyResultManagement,
  },
]

export default academyRoutes
